import { AlertCircle, Check, Clock, RefreshCw, XCircle } from 'lucide-react'

function StatusIndicator({ status, message, onRetryClick }) {
  if (!status)
    return null

  switch (status.toLowerCase()) {
    case 'delivered':
      return (
        <div className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-blue-400/30 backdrop-blur-sm text-white">
          <Check size={10} className="text-white" />
          <span className="text-[9px] font-medium">Delivered</span>
        </div>
      )
    case 'failed':
      return (
        <div className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-red-500/20 backdrop-blur-sm text-white">
          <XCircle size={10} className="text-white" />
          <span className="text-[9px] font-medium">Failed to deliver</span>
          <button
            onClick={(e) => {
              e.stopPropagation()
              onRetryClick(message)
            }}
            className="ml-1 bg-white/20 hover:bg-white/30 p-1 rounded-full transition-colors"
          >
            <RefreshCw size={10} className="text-white" />
          </button>
        </div>
      )
    case 'undelivered':
      return (
        <div className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-orange-500/20 backdrop-blur-sm text-white">
          <AlertCircle size={10} className="text-white" />
          <span className="text-[9px] font-medium">Failed to deliver</span>
          <button
            onClick={(e) => {
              e.stopPropagation()
              onRetryClick(message)
            }}
            className="ml-1 bg-white/20 hover:bg-white/30 p-1 rounded-full transition-colors"
          >
            <RefreshCw size={10} className="text-white" />
          </button>
        </div>
      )
    case 'queued':
      return (
        <div className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-blue-400/30 backdrop-blur-sm text-white">
          <Clock size={10} className="text-white" />
          <span className="text-[9px] font-medium">Sending...</span>
        </div>
      )
    default:
      return null
  }
}

export default StatusIndicator
